export default function DocumentsCEConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('documents.ce');
}

DocumentsCEConfiguration.$inject = ['$translatePartialLoaderProvider'];
